/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Generic_ClientInputs */



/**
* | output |
* | --- |
* | "oneAI for Desktop" |
*
* @param {Auth_Device_Generic_ClientInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_generic_client = /** @type {((inputs?: Auth_Device_Generic_ClientInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Generic_ClientInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI für Desktop")
	return /** @type {LocalizedString} */ ("oneAI for Desktop")
});